import { debounce } from '../functions.js';

document.addEventListener('DOMContentLoaded', () => {
    const $navbar = document.getElementById('navbar');

    if ($navbar) {
        const $documentElement = document.documentElement;
        let lastScrollTop = 0;

        const handleScroll = () => {
            const currentScrollTop = window.scrollY;
            if (currentScrollTop === 0) {
                $documentElement.classList.add('is-top');
            } else {
                $documentElement.classList.remove('is-top');
            }
            if (currentScrollTop <= lastScrollTop) {
                $documentElement.classList.add('has-navbar-fixed-top');
                $documentElement.classList.add('scroll-up');
                $documentElement.classList.remove('scroll-down');
            } else {
                $documentElement.classList.remove('has-navbar-fixed-top');
                $documentElement.classList.remove('scroll-up');
                $documentElement.classList.add('scroll-down');
            }

            lastScrollTop = Math.max(0, currentScrollTop);
        };

        const debouncedHandleScroll = debounce(handleScroll, 50);

        window.addEventListener('scroll', debouncedHandleScroll);
    }
});
